const defaultMeta = {
  requiresAuth: true,
}

export default [
  {
    path: '/user/global_view',
    name: 'userGlobalView',
    meta: { ...defaultMeta, sectionName: 'Global View', title: 'Global View - Innovation Law Lab Platform' },
    component: _ => import('@/views/GlobalView.vue'),
    children: [
      {
        path: 'records',
        name: 'userGlobalViewRecords',
        meta: { ...defaultMeta, sectionName: 'Global View - Records', title: 'Global View - Records - Innovation Law Lab Platform' },
        component: _ => import('@/components/GlobalView/GlobalViewRecords.vue'),
      },
      {
        path: 'legal_cases',
        name: 'userGlobalViewLegalCases',
        meta: { ...defaultMeta, sectionName: 'Global View - Legal Cases', title: 'Global View - Legal Cases - Innovation Law Lab Platform' },
        component: _ => import('@/components/GlobalView/GlobalViewLegalCases.vue'),
      },
      {
        path: 'parties',
        name: 'userGlobalViewParties',
        meta: { ...defaultMeta, sectionName: 'Global View - Parties', title: 'Global View - Parties - Innovation Law Lab Platform' },
        component: _ => import('@/components/GlobalView/GlobalViewParties.vue'),
      },
    ],
  },
]
